import DataService from './data.service'

class AuthService {
  login(user) {
    console.log("login")
    return DataService
      .post('auth/login', {
        email: user.email,
        password: user.password
      })
      .then(response => {
        console.log("got user data: ", response.data.data)
        let data = response.data.data;
        if (data.token) {
          localStorage.setItem('user', JSON.stringify(data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  getAuth() {
    if (localStorage.getItem('user'))
      return JSON.parse(localStorage.getItem('user'));
    else
      return null;
  }

  getUser() {
    if (localStorage.getItem('user'))
      return JSON.parse(localStorage.getItem('user'))['user'];
    else
      return null;
  }

  getPermissions() {
    if (localStorage.getItem('user'))
      return JSON.parse(localStorage.getItem('user'))['permissions'];
    else
      return null;
  }

  hasPermission(p) {
    let permissions = this.getPermissions();
    let hasP = false;
    permissions.forEach((per) => {
      if (per == p) {
        hasP = true;
        return;
      }
    });
    return hasP;
  }

  isLoggedIn() {
    return !!localStorage.getItem('user')
  }

  getToken() {
    if (localStorage.getItem('user')) {
      let user = JSON.parse(localStorage.getItem('user'));

      if (user && user.token) {
        return user.token;
      } else {
        return "";
      }
    }
  }

  // register(user) {
  //   return axios.post(API_URL + 'signup', {
  //     username: user.username,
  //     email: user.email,
  //     password: user.password
  //   });
  // }
}

export default new AuthService();